import React from 'react';
export function FinalCTA() {
  return <section className="py-10 md:py-[140px] px-4 md:px-12 text-center relative overflow-hidden z-10" aria-label="Llamado a la acción final" data-id="element-65">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-[radial-gradient(circle,rgba(255,215,0,0.06)_0%,transparent_65%)] pointer-events-none" aria-hidden="true" data-id="element-66" />
      <div className="max-w-[700px] mx-auto relative z-10" data-id="element-67">
        <h2 className="font-display text-[clamp(2.5rem,6vw,6rem)] tracking-[3px] leading-none mb-4 md:mb-6" data-id="element-68">
          DOS CAMINOS.
          <br data-id="element-69" />
          <span className="text-gold" data-id="element-70">UNO CONSTRUYE.</span>
          <br data-id="element-71" />
          <span className="text-cyan" data-id="element-72">UNO CONSUME.</span>
        </h2>
        <p className="font-text text-[0.88rem] md:text-[1.05rem] text-text-silver leading-[1.7] max-w-[560px] mx-auto mb-6 md:mb-12" data-id="element-73">
          Puedes cerrar esta página y seguir siendo esclavo del algoritmo,
          publicando contenido que no convierte. O puedes invertir $14.94 hoy y
          adquirir el Exoesqueleto Digital que convierte cualquier idea en un
          activo de alto ticket.
        </p>
        <a href="#oferta" className="cta-primary inline-flex items-center justify-center gap-3 bg-gradient-to-r from-gold-dark via-gold to-gold-light bg-[length:300%_100%] text-black px-8 md:px-14 py-4 md:py-6 rounded-md font-body text-[0.82rem] md:text-[1rem] font-extrabold tracking-[1px] md:tracking-[2px] uppercase no-underline w-full max-w-[560px]" aria-label="Acceso inmediato por $14.94" data-id="element-74">
          QUIERO MI EXOESQUELETO DIGITAL{' '}
          <span className="cta-arrow text-lg" data-id="element-75">→</span>
        </a>
        <div className="flex flex-col items-center gap-2 mt-4" data-id="element-76">
          <span className="flex items-center gap-2 text-[0.65rem] md:text-[0.75rem] text-text-muted tracking-[1px]" data-id="element-77">
            <span className="w-1.5 h-1.5 rounded-full bg-matrix shadow-[0_0_8px_#00FF41]" aria-hidden="true" data-id="element-78" />
            Acceso inmediato · Garantía 7 días · Sin riesgo
          </span>
        </div>
      </div>
    </section>;
}